import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Produccion() {
  const navigate = useNavigate();

  const modulos = [
    { label: 'Inventario Helados',   desc: 'Bandejas por sabor y PDV',    icon: '🍨', path: '/helados',              color: '#FCE4EC', border: '#F8BBD0' },
    { label: 'Envíos de Helado',     desc: 'Despachos a puntos de venta', icon: '🚚', path: '/envios',               color: '#EFF6FF', border: '#BFDBFE' },
    { label: 'Envíos de Productos',  desc: 'Insumos y empaques',          icon: '📦', path: '/envios-general',       color: '#FEF3C7', border: '#FDE68A' },
    { label: 'Inventario Producción',desc: 'Materias primas e insumos',   icon: '🏭', path: '/inventario-produccion',color: '#F0FDF4', border: '#BBF7D0' },
    { label: 'Producción Helados',   desc: 'Órdenes y semielaborados',    icon: '🧪', path: '/produccion-helados',   color: '#F5F3FF', border: '#DDD6FE' },
  ];

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: '#111827' }}>🏭 Producción</h1>
        <div style={{ fontSize: 13, color: '#6B7280', marginTop: 2 }}>Módulos operativos del día a día</div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        {modulos.map((m) => (
          <button key={m.path} onClick={() => navigate(m.path)}
            style={{ padding: 16, background: m.color, border: `2px solid ${m.border}`, borderRadius: 14, cursor: 'pointer', textAlign: 'left' }}>
            <div style={{ fontSize: 24, marginBottom: 6 }}>{m.icon}</div>
            <div style={{ fontWeight: 700, fontSize: 13, color: '#111827' }}>{m.label}</div>
            <div style={{ fontSize: 11, color: '#6B7280', marginTop: 2 }}>{m.desc}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
